import { render, staticRenderFns } from "./loaderSmall.pug?vue&type=template&id=2b492c57&lang=pug&external"
import script from "./loaderSmall.js?vue&type=script&lang=js&external"
export * from "./loaderSmall.js?vue&type=script&lang=js&external"
import style0 from "./loaderSmall.scss?vue&type=style&index=0&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Multiasistencia\\mavalue\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2b492c57')) {
      api.createRecord('2b492c57', component.options)
    } else {
      api.reload('2b492c57', component.options)
    }
    module.hot.accept("./loaderSmall.pug?vue&type=template&id=2b492c57&lang=pug&external", function () {
      api.rerender('2b492c57', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/loaderSmall/index.vue"
export default component.exports